module.exports = __webpack_public_path__ + "img/ring-my-pro-logo.1bfab632.png";